import { useAuthentication } from '@zenbusiness/application-commons-authentication';

import { getEnterpriseConfig } from '#client/configs/enterprise';

export function useEnterprise() {
  const { enterpriseId } = useAuthentication();

  const enterprise = getEnterpriseConfig(enterpriseId);

  return {
    enterprise,
    loading: false
  };
}
